"use strict";
const { validate: uuidValidate, version: uuidVersion } = require('uuid');
const mySql = require('./mySql');
const attributesConst = require('./attributesConst');
const redisKeys = require('./redisKeys');
const attributesKeys = require('./attributesKeys');
const attributeMetricsMetadata = require('./attributeMetricsMetadata');
/**
 * Will try to get the features parameter from the url, if not exists will take it from the window.location.search
 * @param {string} url
 * @returns
 */
const getFeaturesParameter = (url) => {
    const featuresParam = url
        || window.location.search
            .substr(1)
            .split('&')
            .find((item) => item.startsWith('features='));
    if (!featuresParam) {
        return {};
    }
    const featuresString = decodeURIComponent(featuresParam.split('=')[1]);
    const featuresList = featuresString ? featuresString.split(',') : [];
    return featuresList.reduce((featuresObj, item) => {
        const features = featuresObj;
        if (item.startsWith('-')) {
            features[item.substr('1').trim()] = false;
        }
        features[item.trim()] = true;
        return features;
    }, {});
};
const isFeatureFlagOn = ({ serviceFeatureFlagsMap, featureFlag, url }) => {
    const paramsFeatures = getFeaturesParameter(url);
    if (paramsFeatures[featureFlag] !== undefined) {
        return paramsFeatures[featureFlag];
    }
    return serviceFeatureFlagsMap?.[featureFlag] === true;
};
/**
 *
 * @param {Object} serviceFeaturesMap - Feature flags map from the service
 * @param {Object} featureFlag - Feature flags name to check
 * @param {string} url - Url to check if the feature flags are on as params [Optional, If not provided, will default to window.location.search]
 * @returns
 */
const getFeatureFlag = ({ serviceFeaturesMap, featureFlag, url }) => isFeatureFlagOn({ serviceFeatureFlagsMap: serviceFeaturesMap, featureFlag, url });
const safeParsing = (data, defaultValue, logger, loggerData = {}) => {
    try {
        return JSON.parse(data);
    }
    catch (err) {
        if (logger) {
            logger.error(`${logger.serviceName}: Failed to parse JSON`, loggerData, err, { data });
        }
        return defaultValue;
    }
};
// https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_chunk
const chunk = (input, size) => (input.reduce((arr, item, idx) => (idx % size === 0
    ? [...arr, [item]]
    : [...arr.slice(0, -1), [...arr.slice(-1)[0], item]]), []));
/**
 * Runs promiseToRun - parametersArray.length times but only after the previous promise call is done
 * @param parametersArray Array of params to send in each promise call
 * @param promiseToRun Promise to run
 * @returns {*} Results promise of all the calls
 */
const runPromisesOneByOne = (parametersArray, promiseToRun) => {
    const result = [];
    return parametersArray
        .reduce((acc, currentParameter) => acc.then(() => promiseToRun(currentParameter).then((res) => {
        result.push(res);
    })), Promise.resolve())
        .then(() => result);
};
const maskToken = (token = '') => `${token.substring(0, 8)}${'*'.repeat(30)}${token.substring(38, token.length)}`;
const TOKEN_QUERY_PARAMS = ['token', 'app-token'];
const maskTokensInRequest = (req) => {
    if (req.query && TOKEN_QUERY_PARAMS.some((param) => req.query[param])) {
        const maskedQuery = TOKEN_QUERY_PARAMS.reduce((acc, param) => {
            if (req.query[param]) {
                return { ...acc, [param]: maskToken(req.query[param]) };
            }
            return acc;
        }, { ...req.query });
        return req.originalUrl.replace(/\?.*/, `?${new URLSearchParams(maskedQuery)}`);
    }
    return req.originalUrl;
};
const uuidValidateV4 = (uuid) => uuidValidate(uuid) && uuidVersion(uuid) === 4;
module.exports = {
    safeParsing,
    mySql,
    chunk,
    runPromisesOneByOne,
    attributesConst,
    redisKeys,
    attributesKeys,
    attributeMetricsMetadata,
    maskToken,
    maskTokensInRequest,
    getFeatureFlag,
    getFeaturesParameter,
    isFeatureFlagOn,
    uuidValidateV4,
};
//# sourceMappingURL=index.js.map